import React, { useEffect, useState } from 'react'
import ErrorBoundary from '../../components/ErrorBoundary'
import ErrorView from '../../components/ErrorView'
import MaintenanceErrorView from '../../components/MaintenanceErrorView'
import effects from 'app/effects/effects'
import { Routes } from 'app/services/routeService/routeService'
import { useDispatch, useSelector } from 'react-redux'
import { nullableToMaybe } from 'libs/maybe'
import { resetNavigation } from 'app/store/actions'

export default (props) => {
  const dispatch = useDispatch()
  const isMaintenanceDisabled = useSelector(
    ({ maintenanceConfig }) => maintenanceConfig.isMaintenanceDisable,
  )

  const [isOnMaintenance, setIsOnMaintenance] = useState(nullableToMaybe)
  useEffect(() => {
    // If the app already marked maintenance mode, stay on the page and avoid bouncing to sign-in.
    if (isMaintenanceDisabled) {
      setIsOnMaintenance(true)
      return
    }

    effects.apis
      .refreshTokenManager()
      .then((res) => props.history.push(Routes.notificationTimeline()))
      .catch((error) => {
        setIsOnMaintenance(true)
        if (
          error &&
          error.response.data.status === 503 &&
          error.response.data.details &&
          error.response.data.details.code === 700
        ) {
          dispatch({
            type: 'DISABLED_MAINTENANCE',
            value: true,
          })
        } else {
          dispatch(resetNavigation())
          props.history.push(Routes.signIn())
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMaintenanceDisabled])

  return (
    <>
      {isOnMaintenance === true ? (
        <ErrorBoundary fallBack={<ErrorView />}>
          <MaintenanceErrorView />
        </ErrorBoundary>
      ) : (
        <div />
      )}
    </>
  )
}
